var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLateMorning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-158"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-158",
    cx: 250.25,
    cy: 333.31,
    rx: 236.58,
    ry: 136.59,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.71,296.52,370.65,267a6.64,6.64,0,0,0-5.48-.25l-57.12,26.38c-1.55.71-1.6,2-.13,2.84l63.66,36.75a5.17,5.17,0,0,0,5.17-.27l45.13-32.6A1.84,1.84,0,0,0,421.71,296.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.52,296.52,128.58,267a6.64,6.64,0,0,1,5.48-.25l57.12,26.38c1.55.71,1.6,2,.13,2.84l-63.65,36.75a5.19,5.19,0,0,1-5.18-.27l-45.13-32.6A1.85,1.85,0,0,1,77.52,296.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,361.4,243,454.48a5.61,5.61,0,0,0,5.11,0l165.52-95.63c1.42-.81,1.42-2.13,0-3L252,262.82a5.7,5.7,0,0,0-5.12,0L81.35,358.45C79.93,359.26,79.93,360.59,81.35,361.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.74,107.63c-3.19.23-11.34-.69-16.2,5.33-5.15,6.36-22.91,32-22.91,32l-17.74-26.32-19.66-10.43c.75,9.22,24.2,48.85,27.75,53.68s7.58,9,15.28,2.62,25.41-30.77,25.41-30.77S359.93,107.4,356.74,107.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.72,107.15s-9.7-1.26-15.18,2.34-20.66,26.43-20.66,26.43,1.31,11.11,14.34,14.34l18.48-24.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.74,112.08c6.29-3.63,16.5-3.63,22.8,0,3.14,1.82,4.71,4.19,4.71,6.57v3c0,2.39-1.56,4.77-4.71,6.59-6.3,3.64-16.51,3.64-22.8,0-3.15-1.81-4.71-4.19-4.71-6.56v-3.07C283,116.28,284.59,113.9,287.74,112.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,125.25c-6.3,3.63-16.51,3.63-22.8,0s-6.3-9.53,0-13.17,16.5-3.63,22.8,0S316.84,121.61,310.54,125.25Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.74,108.25c6.29-3.63,16.5-3.63,22.8,0,3.14,1.82,4.71,4.19,4.71,6.57v3.05c0,2.39-1.56,4.77-4.71,6.59-6.3,3.64-16.51,3.64-22.8,0-3.15-1.81-4.71-4.19-4.71-6.56v-3.07C283,112.45,284.59,110.07,287.74,108.25Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,121.42c-6.3,3.64-16.51,3.64-22.8,0s-6.3-9.53,0-13.17,16.5-3.63,22.8,0S316.84,117.78,310.54,121.42Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.71,111.41h22.86c2.54,3.72,2.54,9.64,2.54,10.8s-.13,1.9-2,1.48a50.56,50.56,0,0,0-23.88,0c-1.9.42-2-.32-2-1.48S285.16,115.13,287.71,111.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,119.71a3.74,3.74,0,0,1-2.24,1.72c-.91.23-1.87.15-2.8.29-1.91.29-3.2,1.59-4.92,2.28a5.11,5.11,0,0,1-2.29.36,8,8,0,0,1-2.52-.66c-1.29-.51-2.54-1.16-3.87-1.56a7.08,7.08,0,0,0-3.23-.28,4.34,4.34,0,0,1-2.66-.27c-1.59-.75-2.13-2.81-3.57-3.81-1.14-.8-2.81-.94-3.48-2.15a2.53,2.53,0,0,1,.45-2.77,5.66,5.66,0,0,1,2.51-1.53,22.88,22.88,0,0,1,5.43-1.11c4.15-.42,8.31-.67,12.48-.78s8.1-.24,12.09,1a7.44,7.44,0,0,1,2.54,1.25,3.05,3.05,0,0,1,1.15,2.5,3.25,3.25,0,0,1-1.61,2.08c-.48.33-1,.55-1.51.91A9.79,9.79,0,0,0,312.55,119.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,110a.24.24,0,0,1,0-.13c1.47-5.63,8.35-9.87,16.6-9.87s15.15,4.24,16.62,9.87a.24.24,0,0,1,0,.13,5.72,5.72,0,0,1,.26,1.91c-.07,2.45-1.72,4.88-4.95,6.73-6.61,3.81-17.31,3.81-23.92,0-3.22-1.85-4.88-4.28-4.95-6.73A5.72,5.72,0,0,1,282.49,110Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.05,104.41l10.11-1.76s6.72,2.33,6.79,2.45,3.61,2.31,3.61,2.31c.61.52-.23,1.86-1.45,2a16,16,0,0,1-2.16,0s-2.13,2.17-6.92,2.57-8.12-1.66-9.94-2.26c-1.51-.5-2.45-.86-3.32-.6A11.28,11.28,0,0,1,286.05,104.41Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.9,115.69c4.21,3.21,15,4.27,21.75.86s7-9.17,4.9-11.85a10.88,10.88,0,0,1,3.2,5.12.24.24,0,0,1,0,.13,5.72,5.72,0,0,1,.26,1.91c-.07,2.45-1.72,4.88-4.95,6.73-6.61,3.81-17.31,3.81-23.92,0-3.22-1.85-4.88-4.28-4.95-6.73a5.72,5.72,0,0,1,.26-1.91S282.23,112.89,285.9,115.69Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,111c-2,.6-2.19-3.78-2.1-4.29a5.88,5.88,0,0,1,1.42-3c2.27-2.58,4.59-2.78,7.32-4.59a8.7,8.7,0,0,1,3-1.54,7.82,7.82,0,0,1,3.24.74c4,1.9,11,7.56,10.6,7.23a9,9,0,0,1,1,.93c.4.54-.16,1.2-.55,1.46a4.38,4.38,0,0,1-3.54.52,14.15,14.15,0,0,1-5.93,2.16,14.57,14.57,0,0,1-7.44-.58C284.56,108.09,283.05,107.32,282.27,111Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408,223.2v74.05a2.08,2.08,0,0,0,.94,1.63l2.53,1.45a2.06,2.06,0,0,0,1.87,0l2.53-1.45a2.08,2.08,0,0,0,.94-1.63V223.2a1.08,1.08,0,0,0-1.09-1.08h-6.63A1.08,1.08,0,0,0,408,223.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,223.2v74.05a2.08,2.08,0,0,0,.94,1.63l2.53,1.45a2.06,2.06,0,0,0,1.87,0l2.53-1.45a2.08,2.08,0,0,0,.94-1.63V223.2a1.08,1.08,0,0,0-1.09-1.08h-6.63A1.08,1.08,0,0,0,408,223.2Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.7,222.12h-2.23a1.08,1.08,0,0,0-1.09,1.08v76.59c0,.6.42.84.93.54l2.53-1.45a2.08,2.08,0,0,0,.94-1.63V223.2A1.08,1.08,0,0,0,415.7,222.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.7,222.12h-2.23a1.08,1.08,0,0,0-1.09,1.08v76.59c0,.6.42.84.93.54l2.53-1.45a2.08,2.08,0,0,0,.94-1.63V223.2A1.08,1.08,0,0,0,415.7,222.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49,247.64v74.05a2,2,0,0,0,.94,1.62l2.52,1.46a2.08,2.08,0,0,0,1.88,0l2.52-1.46a2,2,0,0,0,.94-1.62V247.64a1.08,1.08,0,0,0-1.08-1.09h-6.64A1.09,1.09,0,0,0,365.49,247.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49,247.64v74.05a2,2,0,0,0,.94,1.62l2.52,1.46a2.08,2.08,0,0,0,1.88,0l2.52-1.46a2,2,0,0,0,.94-1.62V247.64a1.08,1.08,0,0,0-1.08-1.09h-6.64A1.09,1.09,0,0,0,365.49,247.64Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21,246.55H371a1.09,1.09,0,0,0-1.09,1.09v76.59c0,.6.42.84.94.54l2.52-1.46a2,2,0,0,0,.94-1.62V247.64A1.08,1.08,0,0,0,373.21,246.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21,246.55H371a1.09,1.09,0,0,0-1.09,1.09v76.59c0,.6.42.84.94.54l2.52-1.46a2,2,0,0,0,.94-1.62V247.64A1.08,1.08,0,0,0,373.21,246.55Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,193.28a4,4,0,0,1-3.45,4.43l-.49,0a4,4,0,0,1-3.94-3.48c-2.29-18.28,1-59.17,8.79-82.21.8-2.37,3.09-2.89,5.25-1.64h0c1.65,1,2.85,2.4,2.22,4.2C369.2,136.25,366.11,175.67,368.31,193.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.37,203.8a2.42,2.42,0,0,0,.79-.13,2.52,2.52,0,0,0,1.61-3.19c-5.86-17.81-34.65-33.65-53.24-33.65a2.53,2.53,0,1,0,0,5c16.82,0,43.33,14.64,48.44,30.18A2.54,2.54,0,0,0,414.37,203.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09,180.71a2.47,2.47,0,0,0,.79-.13,2.53,2.53,0,0,0,1.61-3.19c-6.09-18.5-35.75-33.47-54.26-31.57a2.53,2.53,0,0,0,.52,5c16.4-1.67,43.6,11.91,48.94,28.12A2.51,2.51,0,0,0,417.09,180.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,162.41a2.58,2.58,0,0,0,1-.21,2.53,2.53,0,0,0,1.3-3.33c-8.71-19.84-39.7-36.13-56.46-33.8a2.53,2.53,0,0,0,.7,5c14.81-2.06,43.34,13.1,51.13,30.82A2.54,2.54,0,0,0,422.71,162.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.37,203.8a2.42,2.42,0,0,0,.79-.13,2.52,2.52,0,0,0,1.61-3.19c-5.86-17.81-34.65-33.65-53.24-33.65a2.53,2.53,0,1,0,0,5c16.82,0,43.33,14.64,48.44,30.18A2.54,2.54,0,0,0,414.37,203.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M417.09,180.71a2.47,2.47,0,0,0,.79-.13,2.53,2.53,0,0,0,1.61-3.19c-6.09-18.5-35.75-33.47-54.26-31.57a2.53,2.53,0,0,0,.52,5c16.4-1.67,43.6,11.91,48.94,28.12A2.51,2.51,0,0,0,417.09,180.71Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M422.71,162.41a2.58,2.58,0,0,0,1-.21,2.53,2.53,0,0,0,1.3-3.33c-8.71-19.84-39.7-36.13-56.46-33.8a2.53,2.53,0,0,0,.7,5c14.81-2.06,43.34,13.1,51.13,30.82A2.54,2.54,0,0,0,422.71,162.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M429.14,141.18a4,4,0,0,1,1.63,5c-9.13,21.33-13.94,47.4-13.94,75.94V226l-.3.31a1.61,1.61,0,0,1-1.2.49,4.76,4.76,0,0,1-1.66-.4,5.6,5.6,0,0,0-.81-.26,4,4,0,0,1-4-4c0-29.6,5-56.74,14.6-79.08a4,4,0,0,1,5.64-1.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.14,141.18a4,4,0,0,1,1.63,5c-9.13,21.33-13.94,47.4-13.94,75.94V226l-.3.31a1.61,1.61,0,0,1-1.2.49,4.76,4.76,0,0,1-1.66-.4,5.6,5.6,0,0,0-.81-.26,4,4,0,0,1-4-4c0-29.6,5-56.74,14.6-79.08a4,4,0,0,1,5.64-1.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.79,225v1a6.35,6.35,0,0,1-2.35,4.59L372.23,261.1a4.82,4.82,0,0,1-4.84.25L307.85,227a5.54,5.54,0,0,1-2.5-4.34v-1a4.94,4.94,0,0,1,2.62-4.11l53.43-24.67a6.25,6.25,0,0,1,5.13.23l47.75,27.6A5.52,5.52,0,0,1,416.79,225Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.79,225v1a6.35,6.35,0,0,1-2.35,4.59L372.23,261.1a4.82,4.82,0,0,1-4.84.25L307.85,227a5.54,5.54,0,0,1-2.5-4.34v-1a4.94,4.94,0,0,1,2.62-4.11l53.43-24.67a6.25,6.25,0,0,1,5.13.23l47.75,27.6A5.52,5.52,0,0,1,416.79,225Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.28,220.7l-47.75-27.6a6.25,6.25,0,0,0-5.13-.23L308,217.54c-1.44.67-1.5,1.86-.12,2.66l59.54,34.37a4.84,4.84,0,0,0,4.84-.24l42.21-30.49A1.73,1.73,0,0,0,414.28,220.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.61,
    y: 307.61,
    width: 11.71,
    height: 20.37,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.22 313.49 291.01 314.14 291.3 311.68 291.4 309.85 292.53 291.95 305.84 292.41 303.95 310.28 303.82 311.65 303.22 313.49",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,324.76v-1c-1.51,0-6.87,11.34-12,16-4.08,3.73-11.25,8.82-11.08,12.35.22,4.55,6.72,6.57,12.32,5.26,4.38-1,10.63-3.68,13.63-6.92s4-7.49,5.54-9.61,5.18-4.49,6-6.94c.46-1.35-.09-4.3-.75-6.79-.59-2.29-1.24-4.8-2-4.59v1.41c-.93,1-3.53,2.08-6.46,2.19C340.94,326.2,337.62,326.21,337.64,324.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41,309.85c-.62,0-1.2.78-2.69,2.13-1.81,1.62-5.64,3.15-8.41,4.23-4.64,1.81-16.53,3.73-20.6,5.13-2.54.88-2.27,4.72,1,7.17,2.43,1.82,10.5,4.11,18,3.14,4.07-.52,10.38-2.73,13.39-2.93,3.29-.21,9.32-.29,11.89-1.74s1.94-5.1,1.53-8.22c-.44-3.42-.4-8.6-1.52-8.48l-.13,1.38c-1.63,2-9.53,1.9-12.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.2,198.24c2.61,18.39-.91,21.92-18.39,39.54-9.39,9.47-29.77,25.71-29.77,25.71s3.37,7.34,3.5,20.51c.11,11.6-2.73,33.8-2.73,33.8s-7.08,3.95-12.5.5c0,0-12.59-61-11.57-65.24.71-3,23-31.77,23-31.77l6.26-4-40.46,24.93s1.23,11.16.4,18.29c-1.72,14.8-5.7,24.32-9.79,43,0,0-9.66,1.57-13.95-1.77,0,0-.26-63.94-.26-69.58,0-8.58,37.25-34.19,44.3-40.15,4-3.4,8.51-7,8.51-7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,195.67c-.26,10.92-3,20.92-12.54,30.89-14.44,15.15-37.72,26.82-36.68,33.49s6.56,24.28,7.79,42.41c.35,5.05.5,10.94.54,16.8a17.84,17.84,0,0,0,3.87-1.46s2.84-22.2,2.73-33.8c-.13-13.17-3.5-20.51-3.5-20.51s20.38-16.24,29.77-25.71c17.48-17.62,21-21.15,18.39-39.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,217.32a38,38,0,0,1-13-15.52s.57,8.13,3.6,12.87c2.27,3.55-31.1,27.58-31.1,27.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.23,107.41c.55.14,13.36,2.37,13.36,2.37,5.44,1.24,2.65,1.79,5.75,2.84l-1,38.77-.23,50.12c-8.43,9.18-50.85,5-56.05-14.51V128.34c0-9.38,5.21-20.64,19.59-21.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.11,201.51l.23-50.12.76-29.55-11.35-4.23c-2.86,9.16.86,27.66,2.84,36.08s.5,28-3.88,33.2-29.79,18.42-44.65.11C347.26,206.51,389.68,210.69,398.11,201.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.85,190.72c10-3.17,36.55-19.36,36.55-19.36l-12.28-38.13s-1.82-16.92,2.47-23.45c9.21.71,12.36,5.47,13.88,12.29s15.71,51,14.63,55.44c-1,4.2-36.09,22.12-49.69,24.29C372.41,201.8,359,193.21,366.85,190.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,109.21s-3.83,5.26-2.19,14.94A146.3,146.3,0,0,0,393,143.64c2.16,7.08,6.33,19.79,6.33,19.79s11.66,2.27,19.94-9.38c0,0-5-18.51-9.07-29.2C405.26,111.84,400.38,109,390.35,109.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,175.72l-24.5,0,1.86,28.87h0c.12,1,1.1,2.09,3,2.89a21.7,21.7,0,0,0,14.7,0c1.94-.8,3-1.84,3.07-2.89h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.47,175.75l.38,5.86a11,11,0,0,0,2,1.1c5.3,2.19,14,2.19,19.52,0,.24-.1.44-.2.65-.3a12.13,12.13,0,0,0,1.54-.86l.37-5.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.41,176.7v-4.06h-2.62c-.35-.18-.74-.36-1.16-.53-5-2-13.07-2-17.94,0-.41.17-.77.35-1.11.53H346v4.06h0c0,1.32,1.22,2.64,3.66,3.65,4.87,2,12.9,2,17.94,0C370.15,179.34,371.41,178,371.41,176.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.63,169c-5-2-13.07-2-17.94,0s-4.88,5.29,0,7.3,12.9,2,17.94,0S372.67,171,367.63,169Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.17,171.5h0l-1-2.71H350.28l-1,2.71h0c-.38,1.05.5,2.16,2.66,3a22.49,22.49,0,0,0,13.49,0C367.65,173.66,368.56,172.55,368.17,171.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,166.9a20,20,0,0,0-12,0c-3.26,1.23-3.26,3.21,0,4.44a20.13,20.13,0,0,0,12,0C368.05,170.11,368.05,168.13,364.68,166.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,169.12s-.09.21-.37.42a5.42,5.42,0,0,1-1.39.7,17.35,17.35,0,0,1-5.64.85,16.58,16.58,0,0,1-5.55-.84,4.87,4.87,0,0,1-1.34-.71c-.27-.22-.35-.38-.35-.42s.29-.6,1.69-1.13a16.58,16.58,0,0,1,5.55-.84,17.08,17.08,0,0,1,5.64.85C365.68,168.5,366,169,366,169.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,169.54a5.42,5.42,0,0,1-1.39.7,17.35,17.35,0,0,1-5.64.85,16.58,16.58,0,0,1-5.55-.84,4.87,4.87,0,0,1-1.34-.71,4.91,4.91,0,0,1,1.34-.7,16.56,16.56,0,0,1,5.55-.85,17.35,17.35,0,0,1,5.64.85A5.42,5.42,0,0,1,365.67,169.54Z",
    style: {
      fill: "#263238"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.29,169.62a1.74,1.74,0,0,1,1.33-.26c.25.14.05.48-.44.77a1.68,1.68,0,0,1-1.33.25C361.6,170.24,361.8,169.9,362.29,169.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,185.58c-2.19,1.11-7.9-1-7.9-1l-.29,4.41s-1,2-7.39,3.31-9.13-.71-12.13.17-1.11,7.82,1.15,10.59,15.1,6.8,28.93-3.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.14,
    cy: 65.65,
    rx: 16.05,
    ry: 17.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.85,76.36c1.58-8.85,1.9-12.85-.26-15a6.42,6.42,0,0,0-5.31-1.87l-1.44,16h0l-2.17,11.42-.22,10a4.86,4.86,0,0,0,4.29-3c1.24-2.46,3.77-12.22,4.73-16l.11,0c.1-.51.19-1,.27-1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,78.68c1,.62,2.53-1.39,3.82-2.74s5.5-3.19,7.6,1.23-1.85,10.47-5.16,11.51c-5.72,1.8-6.57-1.87-6.57-1.87l-.44,20.6s-3.74,9.15-13.87,10.53-8-7-4.71-11.07V100.6s-5.17.78-7.69.39c-4.2-.65-6.85-4-8.12-8.51-2.05-7.3-3-13.74-1.77-27.27,1.42-15.8,20.89-16.19,30.78-10S381,78.68,381,78.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,80.44c.52,0,2.52-3.31,3.82-4.5,1.81-1.64-.52-16.5-.52-16.5s1.82-5.64-1.74-9.37c-3.84-4-10.78-3.18-15.78-3.21a53.78,53.78,0,0,1-10.69-.8,37.82,37.82,0,0,1-6.68-2.19c-1.81-.76-3.85-1.61-5.66-.85a5.24,5.24,0,0,0-2.49,2.67c-2.34,4.92-.15,10.85,4.14,13.86a18.2,18.2,0,0,0,9.3,3c7,.44,16.86-.69,19.45-1,1.94-.27,2.35,1.61,3.4,6.75C378.45,72.76,379.21,80.4,381,80.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.27,60.6l6.32-3.4a3.48,3.48,0,0,0-4.78-1.58A3.77,3.77,0,0,0,384.27,60.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.66,100.6s7.85-2,11.12-3.72a10.8,10.8,0,0,0,4.53-4.48,14.67,14.67,0,0,1-2.57,5.28c-2.4,3.07-13.08,5.41-13.08,5.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,76.79a1.88,1.88,0,1,0,1.88-2A1.91,1.91,0,0,0,361.39,76.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,69l4.46,1.1a2.41,2.41,0,0,0-1.73-2.85A2.25,2.25,0,0,0,363.17,69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,89.22l-4.29,1.61a2.25,2.25,0,0,0,2.91,1.42A2.4,2.4,0,0,0,360,89.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.52,69.61,349.87,68A2.23,2.23,0,0,0,347,66.6,2.44,2.44,0,0,0,345.52,69.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,75.88a1.88,1.88,0,1,0,1.88-2A1.91,1.91,0,0,0,347,75.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.14 75.39 355.53 86.69 349.63 84.68 356.14 75.39",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.17,111.61c3.19.23,8.9,0,11.92,4.57,4.49,6.84,20.29,32.39,20.29,32.39l17.74-26.32,19.65-10.43C206,121,182.57,160.67,179,165.5s-7.58,9-15.29,2.62-25.41-30.77-25.41-30.77S134,111.38,137.17,111.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,115.66c-6.3-3.63-16.51-3.63-22.81,0-3.14,1.82-4.7,4.19-4.7,6.57,0,.52,0,2.55,0,3,0,2.39,1.55,4.77,4.7,6.59,6.3,3.64,16.51,3.64,22.81,0,3.14-1.81,4.71-4.19,4.71-6.56v-3.07C204,119.86,202.42,117.48,199.27,115.66Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.87,
    cy: 122.25,
    rx: 16.13,
    ry: 9.31,
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,111.83c-6.3-3.63-16.51-3.63-22.81,0-3.14,1.82-4.7,4.19-4.7,6.57,0,.52,0,2.55,0,3,0,2.39,1.55,4.78,4.7,6.6,6.3,3.63,16.51,3.63,22.81,0,3.14-1.82,4.71-4.2,4.71-6.57v-3.07C204,116,202.42,113.65,199.27,111.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46,125c6.3,3.64,16.51,3.64,22.81,0s6.3-9.53,0-13.17-16.51-3.63-22.81,0S170.17,121.36,176.46,125Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,115H176.44c-2.55,3.72-2.55,9.64-2.55,10.8s.14,1.9,2,1.49a59.78,59.78,0,0,1,11.94-1.44,59.88,59.88,0,0,1,11.94,1.44c1.89.41,2-.33,2-1.49S201.84,118.71,199.3,115Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,123.3A3.72,3.72,0,0,0,176.7,125c.91.23,1.87.15,2.79.29,1.92.29,3.21,1.59,4.92,2.28a5.31,5.31,0,0,0,2.29.37,8.24,8.24,0,0,0,2.53-.67c1.29-.51,2.53-1.16,3.86-1.56a7.08,7.08,0,0,1,3.23-.28,4.31,4.31,0,0,0,2.67-.27c1.59-.75,2.13-2.81,3.57-3.81,1.13-.8,2.81-.94,3.48-2.15a2.55,2.55,0,0,0-.45-2.77,5.78,5.78,0,0,0-2.52-1.53,22.77,22.77,0,0,0-5.43-1.1c-4.14-.43-8.31-.68-12.47-.79s-8.11-.24-12.09,1a7.2,7.2,0,0,0-2.54,1.26,3,3,0,0,0-1.15,2.49,3.23,3.23,0,0,0,1.6,2.08c.49.33,1,.55,1.52.91A10.12,10.12,0,0,1,174.46,123.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51,113.53a.35.35,0,0,0,0-.13c-1.47-5.63-8.35-9.87-16.61-9.87s-15.14,4.24-16.62,9.87a.35.35,0,0,0,0,.13,5.76,5.76,0,0,0-.26,1.91c.07,2.45,1.72,4.88,4.95,6.73,6.6,3.81,17.31,3.81,23.92,0,3.21-1.85,4.87-4.28,4.94-6.73A5.28,5.28,0,0,0,204.51,113.53Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,108l-10.11-1.76s-6.73,2.33-6.8,2.45-3.61,2.31-3.61,2.31c-.61.53.24,1.86,1.45,2a14.2,14.2,0,0,0,2.16,0s2.14,2.17,6.92,2.57,8.12-1.66,9.95-2.26c1.51-.5,2.44-.86,3.31-.6A11.17,11.17,0,0,0,201,108Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,119.27c-4.22,3.21-15,4.27-21.75.87s-7.05-9.18-4.9-11.86a10.9,10.9,0,0,0-3.21,5.12.35.35,0,0,0,0,.13,5.76,5.76,0,0,0-.26,1.91c.07,2.45,1.72,4.88,4.95,6.73,6.6,3.81,17.31,3.81,23.92,0,3.21-1.85,4.87-4.28,4.94-6.73a5.28,5.28,0,0,0-.26-1.91S204.78,116.47,201.11,119.27Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.74,114.58c2,.6,2.18-3.78,2.1-4.29a5.86,5.86,0,0,0-1.43-3c-2.26-2.58-4.58-2.78-7.32-4.59a8.7,8.7,0,0,0-3.05-1.54,7.81,7.81,0,0,0-3.23.74c-4,1.9-11,7.56-10.61,7.23a11.7,11.7,0,0,0-1,.93c-.41.54.15,1.2.54,1.46a4.41,4.41,0,0,0,3.55.52,14,14,0,0,0,5.92,2.16,14.61,14.61,0,0,0,7.45-.58C202.44,111.67,204,110.9,204.74,114.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.35,224.84v74a2.08,2.08,0,0,1-.94,1.63L87.88,302A2.06,2.06,0,0,1,86,302l-2.53-1.45a2.1,2.1,0,0,1-.93-1.63v-74a1.08,1.08,0,0,1,1.08-1.09h6.63A1.08,1.08,0,0,1,91.35,224.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.35,224.84v74a2.08,2.08,0,0,1-.94,1.63L87.88,302A2.06,2.06,0,0,1,86,302l-2.53-1.45a2.1,2.1,0,0,1-.93-1.63v-74a1.08,1.08,0,0,1,1.08-1.09h6.63A1.08,1.08,0,0,1,91.35,224.84Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,223.75h2.23A1.09,1.09,0,0,1,87,224.84v76.59c0,.6-.42.84-.94.54l-2.53-1.45a2.1,2.1,0,0,1-.93-1.63v-74A1.08,1.08,0,0,1,83.63,223.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,223.75h2.23A1.09,1.09,0,0,1,87,224.84v76.59c0,.6-.42.84-.94.54l-2.53-1.45a2.1,2.1,0,0,1-.93-1.63v-74A1.08,1.08,0,0,1,83.63,223.75Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,249.28v74a2.06,2.06,0,0,1-.94,1.62l-2.52,1.46a2.08,2.08,0,0,1-1.88,0L126,325a2.06,2.06,0,0,1-.94-1.62v-74a1.08,1.08,0,0,1,1.08-1.09h6.64A1.08,1.08,0,0,1,133.84,249.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,249.28v74a2.06,2.06,0,0,1-.94,1.62l-2.52,1.46a2.08,2.08,0,0,1-1.88,0L126,325a2.06,2.06,0,0,1-.94-1.62v-74a1.08,1.08,0,0,1,1.08-1.09h6.64A1.08,1.08,0,0,1,133.84,249.28Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.12,248.19h2.24a1.08,1.08,0,0,1,1.08,1.09v76.59c0,.6-.42.84-.94.54L126,325a2.06,2.06,0,0,1-.94-1.62v-74A1.08,1.08,0,0,1,126.12,248.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.12,248.19h2.24a1.08,1.08,0,0,1,1.08,1.09v76.59c0,.6-.42.84-.94.54L126,325a2.06,2.06,0,0,1-.94-1.62v-74A1.08,1.08,0,0,1,126.12,248.19Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,194.92a4,4,0,0,0,3.45,4.43l.49,0a4,4,0,0,0,3.95-3.48c2.28-18.28-1-59.17-8.8-82.22-.8-2.36-3.09-2.88-5.25-1.63h0c-1.65,1-2.84,2.4-2.22,4.2C130.14,137.89,133.22,177.31,131,194.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,205.44a2.42,2.42,0,0,1-.79-.13,2.53,2.53,0,0,1-1.61-3.19c5.86-17.81,34.65-33.65,53.24-33.65a2.53,2.53,0,1,1,0,5.05c-16.81,0-43.32,14.64-48.44,30.18A2.54,2.54,0,0,1,85,205.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,182.35a2.38,2.38,0,0,1-.79-.13A2.53,2.53,0,0,1,79.84,179c6.09-18.5,35.75-33.47,54.26-31.57a2.53,2.53,0,1,1-.52,5c-16.4-1.67-43.6,11.91-48.93,28.12A2.52,2.52,0,0,1,82.25,182.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.62,164.05a2.58,2.58,0,0,1-1-.21,2.53,2.53,0,0,1-1.3-3.33c8.71-19.84,39.7-36.13,56.46-33.8a2.52,2.52,0,1,1-.7,5c-14.81-2.05-43.34,13.1-51.13,30.83A2.52,2.52,0,0,1,76.62,164.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85,205.44a2.42,2.42,0,0,1-.79-.13,2.53,2.53,0,0,1-1.61-3.19c5.86-17.81,34.65-33.65,53.24-33.65a2.53,2.53,0,1,1,0,5.05c-16.81,0-43.32,14.64-48.44,30.18A2.54,2.54,0,0,1,85,205.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.25,182.35a2.38,2.38,0,0,1-.79-.13A2.53,2.53,0,0,1,79.84,179c6.09-18.5,35.75-33.47,54.26-31.57a2.53,2.53,0,1,1-.52,5c-16.4-1.67-43.6,11.91-48.93,28.12A2.52,2.52,0,0,1,82.25,182.35Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.62,164.05a2.58,2.58,0,0,1-1-.21,2.53,2.53,0,0,1-1.3-3.33c8.71-19.84,39.7-36.13,56.46-33.8a2.52,2.52,0,1,1-.7,5c-14.81-2.05-43.34,13.1-51.13,30.83A2.52,2.52,0,0,1,76.62,164.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.19,142.82a4,4,0,0,0-1.63,5c9.13,21.33,13.94,47.4,13.94,75.94v3.82l.31.32a1.57,1.57,0,0,0,1.19.49,4.76,4.76,0,0,0,1.66-.4,5.6,5.6,0,0,1,.81-.26,4,4,0,0,0,4-4c0-29.6-5-56.74-14.61-79.08a4,4,0,0,0-5.63-1.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.19,142.82a4,4,0,0,0-1.63,5c9.13,21.33,13.94,47.4,13.94,75.94v3.82l.31.32a1.57,1.57,0,0,0,1.19.49,4.76,4.76,0,0,0,1.66-.4,5.6,5.6,0,0,1,.81-.26,4,4,0,0,0,4-4c0-29.6-5-56.74-14.61-79.08a4,4,0,0,0-5.63-1.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55,226.67v1a6.3,6.3,0,0,0,2.34,4.58l42.21,30.52a4.84,4.84,0,0,0,4.84.25l59.54-34.38a5.51,5.51,0,0,0,2.5-4.33v-1a4.92,4.92,0,0,0-2.62-4.1l-53.43-24.67a6.23,6.23,0,0,0-5.12.23l-47.76,27.6A5.54,5.54,0,0,0,82.55,226.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55,226.67v1a6.3,6.3,0,0,0,2.34,4.58l42.21,30.52a4.84,4.84,0,0,0,4.84.25l59.54-34.38a5.51,5.51,0,0,0,2.5-4.33v-1a4.92,4.92,0,0,0-2.62-4.1l-53.43-24.67a6.23,6.23,0,0,0-5.12.23l-47.76,27.6A5.54,5.54,0,0,0,82.55,226.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.05,222.34l47.76-27.6a6.23,6.23,0,0,1,5.12-.23l53.43,24.67c1.45.67,1.5,1.86.12,2.66l-59.54,34.37a4.84,4.84,0,0,1-4.84-.24L84.89,225.48A1.73,1.73,0,0,1,85.05,222.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,326.66c-1,.39-1.33,2.59-1.58,4.19s-1.82,3.45,0,6.38,5.64,4,8.08,8,5.47,11.33,14,13.58,15.28-.28,17-2.78.41-5-5-8.43c-5.71-3.64-7.33-4.71-7.33-4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73,309.33s3.63,11.76,5.91,17.18a59.39,59.39,0,0,0,9.75,15.7c.92,1.07,3,3.05,3.77,3.92a1.66,1.66,0,0,1-.18,2.56c-1.88,1.8-9.87,2.21-14.33-1.15s-8.33-9.9-11-12.6c-1.33-1.35-2.58-2.65-3.5-3.6a3.62,3.62,0,0,1-.89-3.45c.09-.35.2-.75.31-1.23.62-2.58-2.76-13.17-2.76-13.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.47,189.57C92.54,200,91,212.7,94.24,219.72c3.93,8.43,14.86,17,24.88,22.94s25.42,13.17,28.43,14.5,3.32,3.17,2.88,8.91S152,281.2,158.3,293a215.87,215.87,0,0,1,11.18,24.53c2.07,1.36,10.34,2.32,14.29-1.79,0,0-12.2-62.3-14.74-69.8s-30.7-31.83-30.7-31.83,9.49-16.6,11.74-25.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.19,278.63c-2.53-9-1.4-18.58-3.57-22.29s-26.17-17.29-37.72-25.88c-10.66-7.93-14-24.64-10.79-41l-11.64.15C92.54,200,91,212.7,94.24,219.72c3.93,8.43,14.86,17,24.88,22.94s25.42,13.17,28.43,14.5,3.32,3.17,2.88,8.91S152,281.2,158.3,293a215.87,215.87,0,0,1,11.18,24.53,13,13,0,0,0,6.84,1.14C170.72,306.79,160.83,284.42,159.19,278.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,308.14c-1,.4-1.33,2.59-1.57,4.19s-1.83,3.45,0,6.38,5.64,4,8.09,8,5.46,11.34,14,13.59,15.29-.29,17-2.78.41-5-5-8.43c-5.71-3.64-7.33-4.71-7.33-4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,290.81s3.63,11.76,5.91,17.19a59.33,59.33,0,0,0,9.76,15.7c.92,1.06,3,3.05,3.77,3.91a1.67,1.67,0,0,1-.19,2.57c-1.88,1.8-9.87,2.21-14.33-1.15s-8.33-9.9-11-12.61c-1.34-1.35-2.59-2.64-3.51-3.6a3.6,3.6,0,0,1-.89-3.44c.09-.35.2-.76.31-1.24.62-2.58-2.76-13.16-2.76-13.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05,170.63c-4.45,9.61-2.59,20.18.3,29s14.48,18.55,24.5,24.49,23,14.31,26,15.65,3.23,3.19,4,8.9c.77,6.1,2.91,14,9.26,25.77,6.71,12.43,10.51,20.52,10.51,20.52A13.31,13.31,0,0,0,210,291.73s-10.71-56.83-13.25-64.34-45.13-37.16-45.13-37.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.63,235c-1.34-1.44-2.72-2.8-4.09-4.11-4.36-4.14-15.53-14.18-19.41-17.67a47.28,47.28,0,0,0,2.8-8.21s-2.22,4-4.17,7h0l-1.23,1.79-.19.27h0l.08.08c.86.74,8.39,7.28,15.79,14.43C157.86,230.84,161.5,233.11,164.63,235Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,152.78c.24,2.26-.62,8.34-.62,8.34,2.78,12.32,4.5,28.41,4.5,28.41-6.57,11.93-46.95,21.91-57.67,7.12,2.87-10.64,9.39-28.74,9.39-28.74l-5.09-20.77S106.66,134,98.59,116l13-2,18.09-2.65,7.49.31s9.38,10.73,12.46,18.39C151.54,134.76,155,143,146.71,152.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,189.54s-6.65,6.23-12.66,5-21.4-19.69-23.35-25.2-5.71-29.38-7.3-33.43l-6.12,1.41a28.22,28.22,0,0,1-3.94,9.85l5.09,20.77s-6.52,18.1-9.39,28.74C103.64,211.44,144,201.46,150.59,189.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.12,77.27c.1-16-10.83-29.57-27.25-29.7A29.85,29.85,0,0,0,101,56.81a3.62,3.62,0,0,0-.15-1.3,3.79,3.79,0,0,0-4.89-2.39l1.72,5.51a3.92,3.92,0,0,0-1.86-1.34,3.79,3.79,0,0,0-4.86,2.44l6.2,2.12a28.23,28.23,0,0,0-4.06,14.42h0c-.12,17.5,14.37,31.77,32.29,31.79l24.77,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.89,66.39c3.1,1.72,5.75,4,5.82,20.06,0,13.64-4.28,17.13-6.47,18.16s-6.48.56-10.66,0l.1,6.71s6,3.69,3.79,6.53c-2.29,3-6.41,3.42-11.72,2.11a21.42,21.42,0,0,1-10.16-6l-.4-18.9s-2.38,2.44-6.63-1.08c-3.51-2.9-4.8-7.92-2.21-10.7a6,6,0,0,1,9.55,1.63c8.93,0,10.6-10.25,11.17-16.45C128,63.35,135.71,75.64,140.89,66.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,89.39l-2.21-7.28a3.69,3.69,0,0,1,4.78,2.39A4,4,0,0,1,113.26,89.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,82.37a1.71,1.71,0,1,1-1.84-1.65A1.75,1.75,0,0,1,129.64,82.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.16,95l4,1.16a2.05,2.05,0,0,1-2.55,1.5A2.21,2.21,0,0,1,132.16,95Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.29,78.05l-3.54-2.31a2,2,0,0,1,2.87-.67A2.23,2.23,0,0,1,144.29,78.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,78.05l3.54-2.31a2,2,0,0,0-2.87-.67A2.23,2.23,0,0,0,126.08,78.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.29,81.78a1.72,1.72,0,1,1-1.85-1.65A1.76,1.76,0,0,1,143.29,81.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.93 81.05 135.13 92.22 140.51 90.39 134.93 81.05",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,104.59c-4.4-.46-13.49-2.8-15-6.33a9.21,9.21,0,0,0,3.29,4.46c2.76,2.24,11.78,4.6,11.78,4.6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,65.35s-2.31,13.34-20.88,13.74V64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65,220.18c-8.74-4.23-14.05-5.78-20.39-11.1s-36.4-34.39-36.4-34.39l-3.58-38.81s.37-12.83-8.69-19.91c-7.37,1.11-11.73,7.94-11.46,14.92s4.38,48,6.55,51.92c2.07,3.8,38.5,30.71,43.57,34.57h0c3.9,3.31,1.84,5.26,7.75,8.49,3.16,1.72,13.53,3.44,18.19,5.37,5.86,2.42,11.61-1.37,14.54-2.63C181,227.22,176.39,224.41,167.65,220.18Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.75,432.3a1.59,1.59,0,0,0,.95,1.4,5.22,5.22,0,0,0,4.7,0,1.68,1.68,0,0,0,1-1.39h0l.09-102.65-6.64.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,434.23a4.74,4.74,0,0,0,2-.55,1.68,1.68,0,0,0,1-1.39h0l.09-102.65-3,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,331.06a5.16,5.16,0,0,0,4.7,0c1.31-.75,1.33-2,0-2.71a5.16,5.16,0,0,0-4.7,0C259.52,329.11,259.5,330.32,260.79,331.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85,358.81a1.57,1.57,0,0,0,.95,1.4,5.22,5.22,0,0,0,4.7,0,1.66,1.66,0,0,0,1-1.38h0l.09-102.66-6.65.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.51,360.74a4.7,4.7,0,0,0,2-.55,1.66,1.66,0,0,0,1-1.38h0l.09-102.66-3,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,257.58a5.19,5.19,0,0,0,4.7,0c1.31-.75,1.33-2,0-2.71a5.22,5.22,0,0,0-4.7,0C387.62,255.62,387.6,256.83,388.89,257.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,358.81a1.57,1.57,0,0,0,1,1.4,5.22,5.22,0,0,0,4.7,0,1.7,1.7,0,0,0,1-1.38h0l.09-102.66-6.65.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,360.74a4.75,4.75,0,0,0,2-.55,1.7,1.7,0,0,0,1-1.38h0l.09-102.66-3,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,257.58a5.19,5.19,0,0,0,4.7,0c1.31-.75,1.32-2,0-2.71a5.24,5.24,0,0,0-4.71,0C108.25,255.62,108.24,256.83,109.53,257.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.79,257.05v-1a5.63,5.63,0,0,1,2.56-4.43L246.86,156a5.7,5.7,0,0,1,5.12,0l161.61,93.08a5.63,5.63,0,0,1,2.56,4.43v1a5.63,5.63,0,0,1-2.56,4.43L248.07,354.56a5.68,5.68,0,0,1-5.11,0L81.35,261.48A5.64,5.64,0,0,1,78.79,257.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.79,257.05v-1a5.63,5.63,0,0,1,2.56-4.43L246.86,156a5.7,5.7,0,0,1,5.12,0l161.61,93.08a5.63,5.63,0,0,1,2.56,4.43v1a5.63,5.63,0,0,1-2.56,4.43L248.07,354.56a5.68,5.68,0,0,1-5.11,0L81.35,261.48A5.64,5.64,0,0,1,78.79,257.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,348.24v6.93a5.44,5.44,0,0,1-2.56-.61L81.35,261.49a5.66,5.66,0,0,1-2.56-4.43v-1a5.67,5.67,0,0,1,2.09-4.1c-.93.79-.77,1.89.47,2.62L243,347.63A5.08,5.08,0,0,0,245.52,348.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.52,348.24v6.93a5.44,5.44,0,0,1-2.56-.61L81.35,261.49a5.66,5.66,0,0,1-2.56-4.43v-1a5.67,5.67,0,0,1,2.09-4.1c-.93.79-.77,1.89.47,2.62L243,347.63A5.08,5.08,0,0,0,245.52,348.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,254.55,243,347.63a5.68,5.68,0,0,0,5.11,0L413.59,252c1.42-.81,1.42-2.14,0-2.95L252,156a5.7,5.7,0,0,0-5.12,0L81.35,251.6C79.93,252.41,79.93,253.74,81.35,254.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.35,254.55,243,347.63a5.68,5.68,0,0,0,5.11,0L413.59,252c1.42-.81,1.42-2.14,0-2.95L252,156a5.7,5.7,0,0,0-5.12,0L81.35,251.6C79.93,252.41,79.93,253.74,81.35,254.55Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Food--inject-158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--french-fries--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.61,254.39l-23.49-13.56-1.51-2.35v-2.22l-5.22-2.2-.51-2.2,3.45-.57,2.24.16-.35-1.9,3.09-1.14,43.49,10.07,3.26,1.89a.53.53,0,0,1,0,.92l-22.69,13.1A1.78,1.78,0,0,1,211.61,254.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,227.15l-13.17-11.29-2.24,1.74,2.24,3-3.81-2.49-2,1.66-1.83,1-2.77-1.61-2,1.42.29,1.28,3.6,2a10.68,10.68,0,0,1-1.88.91,21.21,21.21,0,0,1-2.8-1.88l-1.2,2.53,1.66,4.86-2.4.5.38,2.6,3.53,2.61-4.44,1.25.91,2.28s12.35,4.35,12.53,4.35C201.07,243.86,216.1,227.15,216.1,227.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.28 232.47 197.83 242.25 199.5 240.07 184.06 229.71 182.01 230.27 182.28 232.47",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.01 230.27 198.92 240.83 197.83 242.25 182.28 232.47 182.01 230.27",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.74 226.75 197.7 237.85 199.76 236.62 184.33 223.07 184.74 226.75",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.33 223.07 186.98 222.42 201.06 235.26 199.76 236.62 184.33 223.07",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.21 224.91 206.33 233.37 206.33 231.45 191.21 222.66 191.21 224.91",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.21 222.66 193.69 221.83 207.53 230.27 206.33 231.45 191.21 222.66",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.11 232.39 193.36 220.27 193.36 218.06 212.49 231.45 212.11 232.39",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.36 218.06 195.89 217.37 213.61 230.46 212.49 231.45 193.36 218.06",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.99 228.01 202.93 217.37 203.49 219.72 218.89 229.71 219.99 228.01",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.93 217.37 206.33 217.37 220.31 226.91 219.99 228.01 202.93 217.37",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,211.66l.72,1.63s3.43,2.62,7.2,2.17,7.92-3.8,7.92-3.8Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,211.66a15.4,15.4,0,0,0,6.3,1.86c3.89.35,9.54-1.86,9.54-1.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,234.59l17.24,13.27,20.31-11.72-17.24-13.28a14.53,14.53,0,0,0-14.93-1l-4.72,2.72C191.61,227.09,191.31,231.56,195.25,234.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.15,237.77a9.66,9.66,0,0,1-5.78-1.74,4.42,4.42,0,0,1-1.93-3.79,5.14,5.14,0,0,1,2.83-4c3.26-1.88,8.16-1.67,10.93.46a4.43,4.43,0,0,1,1.94,3.79,5.15,5.15,0,0,1-2.84,4A10.44,10.44,0,0,1,210.15,237.77Zm.29-9.78a9.49,9.49,0,0,0-4.67,1.16,4.21,4.21,0,0,0-2.34,3.15,3.45,3.45,0,0,0,1.55,2.93c2.48,1.91,6.88,2.09,9.82.39a4.18,4.18,0,0,0,2.34-3.15,3.45,3.45,0,0,0-1.55-2.92A8.55,8.55,0,0,0,210.44,228Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.49 247.86 212.49 252.55 195.25 242.6 195.25 234.59 212.49 247.86",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.49 247.86 212.49 252.55 195.25 242.6 195.25 234.59 212.49 247.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.8 236.14 232.8 240.83 212.49 252.55 212.49 247.86 232.8 236.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.8 236.14 232.8 240.83 212.49 252.55 212.49 247.86 232.8 236.14",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--french-fries--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.11,254.39l23.49-13.56,1.51-2.35v-2.22l5.22-2.2.5-2.2-3.44-.57-2.25.16.35-1.9-3.08-1.14-43.49,10.07-3.26,1.89a.53.53,0,0,0,0,.92l22.69,13.1A1.78,1.78,0,0,0,291.11,254.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,227.15l13.17-11.29,2.24,1.74-2.24,3,3.81-2.49,2,1.66,1.83,1,2.77-1.61,2,1.42-.29,1.28-3.61,2a10.68,10.68,0,0,0,1.88.91,21.21,21.21,0,0,0,2.8-1.88l1.21,2.53-1.67,4.86,2.4.5-.38,2.6L311.14,236l4.44,1.25-.91,2.28s-12.35,4.35-12.53,4.35C301.72,243.86,286.69,227.15,286.69,227.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.9 226.76 302.35 236.54 300.69 234.35 316.13 224 318.17 224.55 317.9 226.76",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.17 224.55 301.26 235.11 302.35 236.54 317.9 226.76 318.17 224.55",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.05 210.35 279.31 210.06 280.59 208.69 298.78 207.08 300.32 208.53 299.05 210.35",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.32 208.53 279.31 210.06 280.72 211.66 299.05 210.35 300.32 208.53",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.59 235.39 302.4 240.78 300.95 238.86 320.36 232.13 318.59 235.39",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.36 232.13 318.15 230.53 300.26 237.12 300.95 238.86 320.36 232.13",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.18 225.32 297.06 233.78 297.06 231.86 312.18 223.07 312.18 225.32",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.18 223.07 309.71 222.24 295.86 230.68 297.06 231.86 312.18 223.07",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.88 220.38 289.45 231.33 289.12 229.43 302.49 218.16 302.88 220.38",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.49 218.16 299.91 217.78 287.73 228.48 289.12 229.43 302.49 218.16",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.64 233.41 297.55 216.8 296.98 214.67 282.02 232.59 282.64 233.41",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.98 214.67 294.36 214.67 280.69 231.94 282.02 232.59 296.98 214.67",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.43 227.54 312.49 216.9 311.93 219.25 296.53 229.24 295.43 227.54",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.49 216.9 309.09 216.9 295.11 226.44 295.43 227.54 312.49 216.9",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,234.59,290.3,247.86,270,236.14l17.24-13.28a14.53,14.53,0,0,1,14.93-1l4.72,2.72C311.18,227.09,311.48,231.56,307.54,234.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.49,236.49a5.15,5.15,0,0,1-2.84-4,4.45,4.45,0,0,1,1.94-3.79c2.77-2.13,7.67-2.34,10.93-.46a5.17,5.17,0,0,1,2.84,4,4.45,4.45,0,0,1-1.94,3.79,9.66,9.66,0,0,1-5.78,1.74A10.44,10.44,0,0,1,287.49,236.49Zm-.29-6.94a3.45,3.45,0,0,0-1.55,2.92,4.18,4.18,0,0,0,2.34,3.15c2.94,1.7,7.34,1.52,9.82-.39a3.45,3.45,0,0,0,1.55-2.93,4.21,4.21,0,0,0-2.34-3.15,9.48,9.48,0,0,0-4.66-1.16A8.56,8.56,0,0,0,287.2,229.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.3 247.86 290.3 252.55 307.54 242.6 307.54 234.59 290.3 247.86",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.3 247.86 290.3 252.55 307.54 242.6 307.54 234.59 290.3 247.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.99 236.14 269.99 240.83 290.3 252.55 290.3 247.86 269.99 236.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.99 236.14 269.99 240.83 290.3 252.55 290.3 247.86 269.99 236.14",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Soda--inject-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.06,184.64c-5-2.2-13.08-2.2-17.95,0s-4.87,5.76,0,8,12.91,2.2,17.95,0S232.1,186.84,227.06,184.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4,158.6l-24.5,0,1.85,28.87h0c.11,1.05,1.1,2.09,3,2.89a21.7,21.7,0,0,0,14.7,0c1.93-.8,3-1.84,3.07-2.89h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.84,182.1a2.85,2.85,0,0,1-1.72-.55c-1.05-.77-1.62-2.34-1.62-4.4,0-2.76,2-6.32,4.79-7a3.13,3.13,0,0,1,2.8.44c.93.73,1.42,2.14,1.42,4.07s-.91,6.18-4.36,7.24A4.57,4.57,0,0,1,222.84,182.1Zm2.49-11.1a3.49,3.49,0,0,0-.81.11c-2.3.57-4,3.66-4,6,0,1.71.44,3,1.21,3.59a2.31,2.31,0,0,0,2.14.19c2.9-.89,3.66-4.49,3.66-6.28,0-1.62-.36-2.75-1-3.29A1.81,1.81,0,0,0,225.33,171Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,187.5h0c.11,1.05,1.1,2.09,3,2.89a21.7,21.7,0,0,0,14.7,0,5.22,5.22,0,0,0,2.86-2.23,13.14,13.14,0,0,1-8.32,2c-4.75-.53-7.68-1.38-8.53-5.13-.73-3.2-2.46-21-2.92-26.36H205.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,158.63l.37,5.86a11.44,11.44,0,0,0,2,1.1c5.3,2.19,14,2.19,19.52,0,.24-.1.43-.2.65-.3a13.07,13.07,0,0,0,1.54-.86l.37-5.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84,159.58v-4.06h-2.63c-.35-.18-.73-.36-1.15-.53-5-2-13.08-2-17.95,0-.4.17-.76.35-1.1.53h-2.55v4.06h0c0,1.32,1.22,2.64,3.65,3.65,4.87,2,12.91,2,17.95,0C229.58,162.22,230.84,160.9,230.84,159.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,151.87c-5-2-13.08-2-17.95,0s-4.87,5.29,0,7.3,12.91,2,17.95,0S232.1,153.88,227.06,151.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,154.38h0l-1-2.71H209.71l-1,2.71h0c-.38,1.05.5,2.16,2.65,3a22.53,22.53,0,0,0,13.5,0C227.08,156.54,228,155.43,227.59,154.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,149.78a20,20,0,0,0-12,0c-3.26,1.23-3.26,3.21,0,4.44a20.13,20.13,0,0,0,12,0C227.48,153,227.48,151,224.11,149.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,152a1,1,0,0,1-.38.42,5.31,5.31,0,0,1-1.38.7,17.39,17.39,0,0,1-5.64.85,16.64,16.64,0,0,1-5.56-.84,4.62,4.62,0,0,1-1.33-.71c-.28-.22-.35-.38-.35-.42s.29-.6,1.68-1.13a16.64,16.64,0,0,1,5.56-.84,17.12,17.12,0,0,1,5.64.85C225.11,151.38,225.46,151.9,225.47,152Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.09,152.42a5.31,5.31,0,0,1-1.38.7,17.39,17.39,0,0,1-5.64.85,16.64,16.64,0,0,1-5.56-.84,4.62,4.62,0,0,1-1.33-.71,4.66,4.66,0,0,1,1.33-.7,16.63,16.63,0,0,1,5.56-.85,17.39,17.39,0,0,1,5.64.85A5.31,5.31,0,0,1,225.09,152.42Z",
    style: {
      fill: "#263238"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.72,152.5a1.68,1.68,0,0,1,1.33-.25c.25.13,0,.47-.44.76a1.71,1.71,0,0,1-1.34.25C221,153.12,221.23,152.78,221.72,152.5Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLateMorning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/late-morning.7531ed50066d1d94545a619732e93902.svg";